import { Injectable } from '@angular/core';
import { SelectOptions } from '@cbuild/controls';
import { CsHttpClientService } from '@cbuild/cs-common-data-services';
import { Observable } from 'rxjs';

@Injectable()
export class TransferCustomerService {
  constructor(private http: CsHttpClientService) {}

  public getCrmUsers(): Observable<SelectOptions> {
    return this.http.read<SelectOptions>('api/customer/users/get');
  }
}
